import { useContext, useReducer } from "react";
import { Outlet } from "react-router-dom";
import { opportunitiesReducer } from "./opportunitiesReducer";
import { opportunitiesInitialState } from "./opportunitiesInitialState";
import OpportunitiesContext from "./OpportunitiesContext";


export const useOpportunitiesContext = () => useContext(OpportunitiesContext)


export function OpportunitiesProvider() {
    const [opportunitiesState, opportunitiesDispatch] = useReducer(
        opportunitiesReducer,
        opportunitiesInitialState
    )

    return (
        <OpportunitiesContext.Provider value={{ opportunitiesState, opportunitiesDispatch }}>
            <Outlet />
        </OpportunitiesContext.Provider>
    )
}
